import AccessRequestHasBeenCreated from './notification-types/AccessRequestHasBeenCreated'
import MemberHasUpdatedTheirMembership from './notification-types/MemberHasUpdatedTheirMembership'
import MembersHaveBeenAddedToGroupNotification from './notification-types/MembersHaveBeenAddedToGroupNotification'
import ItemHasBeenShared from './notification-types/ItemHasBeenShared'
import DiscussionPostRequiresApprovalNotification
  from './notification-types/DiscussionPostRequiresApprovalNotification'
import DiscussionPostApprovalResponseNotification
  from './notification-types/DiscussionPostApprovalResponseNotification'
import DiscussionReplyRequiresApprovalNotification
  from './notification-types/DiscussionReplyRequiresApprovalNotification'
import DiscussionReplyApprovalResponseNotification
  from './notification-types/DiscussionReplyApprovalResponseNotification'
import EmailHasBeenShared from './notification-types/EmailHasBeenShared'
import SMSHasBeenShared from './notification-types/SMSHasBeenShared'
import BlogEntryHasBeenShared from './notification-types/BlogEntryHasBeenShared'
import MembershipTitleHasBeenUpdatedNotification from './notification-types/MembershipTitleHasBeenUpdatedNotification'
import AccountHasNewRequirements from './notification-types/AccountHasNewRequirements'
import PaymentRefundFailedNotification from './notification-types/PaymentRefundFailedNotification'
import PaymentRefundedNotification from './notification-types/PaymentRefundedNotification'
import BlogEntryHasBeenPublished from './notification-types/BlogEntryHasBeenPublished'

const NotificationFeedMixin = {
  components: {
    SMSHasBeenShared,
    BlogEntryHasBeenShared,
    BlogEntryHasBeenPublished,
    EmailHasBeenShared,
    ItemHasBeenShared,
    AccessRequestHasBeenCreated,
    MemberHasUpdatedTheirMembership,
    MembersHaveBeenAddedToGroupNotification,
    DiscussionPostApprovalResponseNotification,
    DiscussionPostRequiresApprovalNotification,
    DiscussionReplyRequiresApprovalNotification,
    DiscussionReplyApprovalResponseNotification,
    MembershipTitleHasBeenUpdatedNotification,
    AccountHasNewRequirements,
    PaymentRefundedNotification,
    PaymentRefundFailedNotification,
  },
}

export default NotificationFeedMixin